import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';

const mapState = (state) => {
    return {
        porcentaje: state.miPerfil.porcentaje
    };
}

const mapDispatch = (dispatch) => {
    return {}
}

class InformacionDePerfil extends React.Component {
	state = {}

	regresar = () => {
	    goTo("home");
	    //self.window.location = "?#!/home";
	}

	render() {
		return <div className="col-xs-12 hide-mobile">
            <div className="card perfil-card">
                <div className="row">
                    <div className="col-md-2 col-sm-2 barra">
                        <img src={ require("../img/" + this.props.porcentaje + ".svg") } />
                    </div>
                    <div className="col-md-6 col-sm-5">
                        <h5>Información de perfil</h5>
                        <p>Para ofrecerte un mejor servicio recuerda llenar todos los datos de tu perfil y mantenerlos siempre actualizados.</p>
                    </div>
                    <div className="col-md-3 col-sm-4">
                        <p><i className="elements-status"><img src={ require("../img/icon-ocupacion.svg") } /></i>Datos personales</p>
                        <p><i className="elements-status"><img src={ require("../img/icon-share.svg") } /></i>Redes sociales</p>
                        <p><i className="elements-status"><img src={ require("../img/icon-phone.svg") } /></i>Contacto de emergencia</p>
                        <p><i className="elements-status"><img src={ require("../img/icon-document.svg") } /></i>Documentos</p>
                    </div>
                    {/*<div className="col-sm-1 text-right">
                        <button><img src={ require("../img/icon_close.png") } onClick={ this.regresar } /></button>
                    </div>*/}
                </div>
            </div>
        </div>
	}
}

export default connect(mapState, mapDispatch)(InformacionDePerfil);



// WEBPACK FOOTER //
// ./src/miPerfil/informacionDePerfil.cmpt.js